import Http from "../http";
import {
  ETF,
  Statistics,
  Profile,
  Balance,
  Asset,
  PlanParams,
  Plan,
  PlanSchedule,
  Profit
} from "../models/hfox";

export default function(http: Http) {
  return {
    getEtfs(): Promise<ETF[]> {
      return http.get("/hfox/etfs");
    },
    getProfile(): Promise<Profile> {
      return http.get("/hfox/me");
    },
    getStatistics(): Promise<Statistics> {
      return http.get("/hfox/statistics");
    },
    getBalance(): Promise<Balance> {
      return http.get("/hfox/balance");
    },
    getHfoxAssetInfo(id: string): Promise<Asset> {
      return http.get(`/hfox/asset/${id}`);
    },
    getHfoxAssetsToken(): Promise<{ token: string }> {
      return http.get("/hfox/assets/token");
    },
    requestWithdraw(id: string, amount: string, platform: string) {
      return http.post(`/hfox/withdraw/${id}`, { data: { amount, platform } });
    },
    requestCreatePlan(data: PlanParams) {
      return http.post("/hfox/plan", { data });
    },
    getMyPlans(): Promise<Plan[]> {
      return http.get("/hfox/plans");
    },
    getPlanDetail(id: string): Promise<Plan> {
      return http.get(`/hfox/plan/${id}`);
    },
    getPlanSchedules(
      id: string,
      params: { limit?: number; from_number?: number }
    ): Promise<PlanSchedule[]> {
      return http.get(`/hfox/plan/${id}/schedules`, { params });
    },
    requestUpdatePlan(id: string, data: PlanParams) {
      return http.put(`/hfox/plan/${id}`, { data });
    },
    requestDeletePlan(id: string) {
      return http.delete(`/hfox/plan/${id}`);
    },
    getPlanProfits(id: string): Promise<Profit[]> {
      return http.get(`/hfox/plan/${id}/profits`);
    },
    requestCreatePlanSchedules(
      id: string,
      data: { funds: string; trigger: boolean }
    ) {
      return http.post(`/hfox/plan/${id}/schedules`, { data });
    },
    requestImportSchedules(id: string, schedules) {
      return http.put(`/hfox/plan/${id}/schedules`, { data: { schedules } });
    },
    getImportSchedulesStatus(id: string) {
      return http.get(`/hfox/schedules/${id}`);
    },
    requestBindPlatform(data) {
      return http.post("/hfox/user/platform", { data });
    },
    getDepositMemo() {
      return http.get("/hfox/deposit/memo");
    },
    createToushiConnection(id: string) {
      return http.post(`/hfox/plan/${id}/toushi`);
    },
    updateToushiConnection(id: string, value: boolean) {
      return http.put(`/hfox/plan/${id}/toushi/enabled`, {
        data: { enabled: value }
      });
    },
    removeToushiConnection(id: string) {
      return http.delete(`/hfox/plan/${id}/toushi`);
    },
    checkToushiBind() {
      return http.get("/hfox/toushi/check");
    },
    requestToushiBind(code) {
      return http.post("/hfox/toushi/bind", { data: { code } });
    }
  };
}
